import firebase from 'firebase/app'
import 'firebase/storage'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAK8vvSnT7cezWvEX8T3J0bGC0C-VpA8qs",
  authDomain: "brisbane-population.firebaseapp.com",
  databaseURL: "https://brisbane-population.firebaseio.com",
  projectId: "brisbane-population",
  storageBucket: "brisbane-population.appspot.com",
  messagingSenderId: "211212451352",
  appId: "1:211212451352:web:d9edc1455ee33c1e558d6d",
  measurementId: "G-807DS9L8XX"
};

firebase.initializeApp(firebaseConfig);

var storage = firebase.storage();
var storageRoot = storage.ref();

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


/**
 * Utility function to upload a file in a Firebase storage bucket
 *
 * @param {File} rawFile the file to upload
 * @param {File} storageRef the storage reference 
 * @returns {Promise}  the promise of the URL where the file can be download from the bucket
 */ 
async function uploadFileToBucket(rawFile, storageRef) {
    console.log('Beginning upload');
    return storageRef.put(rawFile)
        .then( snapshot => {
            console.log('Uploaded file !');
            // Add url
            return storageRef.getDownloadURL();
        })
        .catch( (error) => { 
            console.log(error);
            throw new Error( { message: error.message_ , status:401} ) 
        });
}

/**
 * Utility function to create or update a file in Firestore
 *
 * @param {String} resource resource name, will be used as a directory to prevent an awful mess in the bucket
 * @param {File} rawFile the file to upload if it is not already there
 * @param {Function} uploadFile the storage reference  
 * @returns {Promise}  the promise of the URL where the file can be download from the bucket
 */ 
export async function createOrUpdateFile(resource, rawFile) {
    console.log("Beginning upload file to storage bucket for file :", rawFile.name);
    var storageRef = storageRoot.child(`${resource}/${uuidv4()}/${rawFile.name}`);
    
    return uploadFileToBucket(rawFile, storageRef)
    // Check if the file already exist (same name, same size)
    // In this case, no need to upload
    // return storageRef.getMetadata()
    //     .then( metadata => {
    //         console.log(metadata)
    //         if ( metadata && metadata.size === rawFile.size) {
    //             console.log("file already exists");
    //             return storageRef.getDownloadURL();
    //         } else {
    //             return uploadFileToBucket(rawFile, storageRef)
    //         }  
    //     })
    //     .catch(
    //         () => { console.log('File does not exist'); return uploadFileToBucket(rawFile, storageRef) }
    //     );
}


